"use client";

import { useSyncExternalStore } from "react";

import type { SmartPaginationFormat } from "@/components/ui/smartPagination";

const LARGE_PAGINATION_MIN_WIDTH = 1536;
const MEDIUM_PAGINATION_MIN_WIDTH = 1280;

export function getListPaginationFormat(viewportWidth: number): SmartPaginationFormat {
  if (viewportWidth >= LARGE_PAGINATION_MIN_WIDTH) return "large";
  if (viewportWidth >= MEDIUM_PAGINATION_MIN_WIDTH) return "medium";
  return "short";
}

function subscribeToViewportResize(onStoreChange: () => void) {
  window.addEventListener("resize", onStoreChange);
  return () => window.removeEventListener("resize", onStoreChange);
}

function getViewportSnapshot() {
  return getListPaginationFormat(window.innerWidth);
}

function getServerSnapshot(): SmartPaginationFormat {
  return "short";
}

export function useListPaginationFormat() {
  return useSyncExternalStore(subscribeToViewportResize, getViewportSnapshot, getServerSnapshot);
}
